import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-cplbzkicon",
  "use": "icon-cplbzkicon-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cplbzkicon\">\r\n<g id=\"icon-cplbzkicon_&#229;&#177;&#149;&#229;&#188;&#128;\">\r\n<path id=\"icon-cplbzkicon_&#229;&#177;&#149;&#229;&#188;&#128;_2\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7 9V16H9V9H16V7H9V0H7V7H0V9H7Z\" fill=\"#25272A\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol